<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/" id="accountOwnerHome">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/myAccountList" [queryParams]="{ tabClicked: 'manageSellers'}" id="settings">My Account</a></li>
      <li class="breadcrumb-item active" aria-current="page">View Seller</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="text-right float-right">
        <button (click)="editSellers()" class="btn btn-orange ml-2">Edit Seller</button>
      </div>
    </div>
  </div>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Details</h2>
          <div class="row mt-3">
            <div class="col-md-12 col-md-8">
              <div class="row">

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="control-label" for="companyName">Company Name</label>
                    <input type="text" id="companyName" [(ngModel)]="viewSeller.companyName" class="form-control"
                           [ngModelOptions]="{standalone: true}" required disabled>
                  </div>
                </div>

                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="firstName">First Name</label>
                    <input type="text" id="firstName" [(ngModel)]="viewSeller.firstName"  [ngModelOptions]="{standalone: true}" class="form-control"
                           autocomplete="off" required disabled>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="lastName">Last Name</label>
                    <input type="text" id="lastName" [(ngModel)]="viewSeller.lastName"  [ngModelOptions]="{standalone: true}" class="form-control" disabled>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="contactNumber">Phone Number</label>
                    <input type="text" id="contactNumber" [(ngModel)]="viewSeller.mobile" [ngModelOptions]="{standalone: true}" class="form-control"  required disabled>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="email">Email</label>
                    <input type="text" id="email" [(ngModel)]="viewSeller.email"  [ngModelOptions]="{standalone: true}" class="form-control" required disabled>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="email">Seller ID</label>
                    <input type="text" id="sellerCode" [(ngModel)]="viewSeller.sellerReferenceCode"  [ngModelOptions]="{standalone: true}" class="form-control" required disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div>
            <h2 class="text-black mb-3">Address</h2>
            <div class="row">
              <div class="col-md-3 required">
                <div class="form-group ">
                  <label class="control-label" for="address1">Address 1</label>
                  <input type="text" id="address1" [(ngModel)]="viewSeller.address1" class="form-control"
                         [ngModelOptions]="{standalone: true}" required disabled>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="address2">Address 2</label>
                  <input type="text" id="address2" [(ngModel)]="viewSeller.address2" class="form-control"
                         [ngModelOptions]="{standalone: true}" required disabled>
                </div>
              </div>
              <div class="col-md-3 required">
                <div class="form-group ">
                  <label class="control-label" for="city">City</label>
                  <input type="text" id="city" [(ngModel)]="viewSeller.city" class="form-control"
                         [ngModelOptions]="{standalone: true}" required disabled>
                </div>
              </div>
              <div class="col-md-3 required">
                <div class="form-group ">
                  <label class="control-label">State</label>
                  <input type="text" id="State" [(ngModel)]="viewSeller.state" class="form-control"
                         [ngModelOptions]="{standalone: true}" required disabled>
                </div>
              </div>
              <div class="col-md-3 required">
                <div class="form-group ">
                  <label class="control-label" for="accountZipAlt">Zip</label>
                  <input type="text" id="accountZipAlt" [(ngModel)]="viewSeller.zipCode" class="form-control"
                         [ngModelOptions]="{standalone: true}" required disabled>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
